export const CARD_FIELDS_KEY = "product-price-matrix:card-fields:v1";
export const DEFAULT_CARD_FIELDS = {
    ram: true,
    storage: true,
    network: true,
    price: true,
    country: false,
    launchDate: false,
    display: false,
    battery: false,
    camera: false,
    chipset: false,
};
export const CARD_FIELD_OPTIONS = [
    ["chipset", "处理器"],
    ["ram", "内存"],
    ["storage", "存储"],
    ["network", "网络"],
    ["camera", "相机"],
    ["display", "显示"],
    ["battery", "电池"],
    ["price", "价格"],
    // ["country", "国家"],
    // ["launchDate", "上市日期"],
];

export function readCardPreferences(storage) {
    try {
        const saved = JSON.parse(storage.getItem(CARD_FIELDS_KEY));
        const fields = { ...DEFAULT_CARD_FIELDS };
        if (saved?.version === 1 && saved.remember !== false) {
            for (const key of Object.keys(fields))
                if (typeof saved.fields?.[key] === "boolean")
                    fields[key] = saved.fields[key];
        }
        return {
            fields,
            remember: saved?.version === 1 ? saved.remember !== false : true,
        };
    } catch {
        return { fields: { ...DEFAULT_CARD_FIELDS }, remember: true };
    }
}

export function saveCardPreferences(storage, fields, remember) {
    try {
        // 关闭记忆时只保存开关，不保存字段，避免下次打开自动重新开启记忆。
        storage.setItem(
            CARD_FIELDS_KEY,
            JSON.stringify({ version: 1, remember, ...(remember ? { fields } : {}) }),
        );
        return true;
    } catch {
        return false;
    }
}
